import EventBus from '@/eventBus'
import _throttle from 'lodash/throttle'
import store from '@/store'
import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  REACTION: 'create-reaction',
}

class ReactionWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.listenEvents()
  }

  listenEvents() {
    if (!store.getters['featureToggles/canUseReactionEmqx']) {
      this.socketClient.on(MESSAGE_TYPES.REACTION, _throttle(this.onCreateReaction.bind(this), 300))
    }
  }

  onCreateReaction(data) {
    EventBus.$emit('reaction-animation', data)
    const { presentation } = this.$store.state
    if (presentation.numberOfHearts < data.numberOfHearts) {
      this.$store.dispatch('patchPresentationAction', {
        numberOfHearts: data.numberOfHearts,
      })
    }
    if (presentation.numberOfLikes < data.numberOfLikes) {
      this.$store.dispatch('patchPresentationAction', {
        numberOfLikes: data.numberOfLikes,
      })
    }
    if (presentation.numberOfLaughs < data.numberOfLaughs) {
      this.$store.dispatch('patchPresentationAction', {
        numberOfLaughs: data.numberOfLaughs,
      })
    }
    if (presentation.numberOfSads < data.numberOfSads) {
      this.$store.dispatch('patchPresentationAction', {
        numberOfSads: data.numberOfSads,
      })
    }
    if (presentation.numberOfWows < data.numberOfWows) {
      this.$store.dispatch('patchPresentationAction', {
        numberOfWows: data.numberOfWows,
      })
    }
  }
}

export default ReactionWebSocketSubscriber
